// extracted by mini-css-extract-plugin
export default {"adminx_wrap":"XWrap_adminx_wrap__TWwtD"};